import { parse, isValid as dateIsValid } from 'date-fns';

/** "14.07.2020" => 2020-07-14T00:00:00.000Z */
export const parseFromHumanToIsoDate = (humanDateStr?: string | null, formatStr = 'dd.MM.yyyy') => {
  if (!humanDateStr) {
    return null;
  }
  const parsedDate = parse(humanDateStr, formatStr, new Date());

  return dateIsValid(parsedDate) ? parsedDate : null;
};
